import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringOrderPrompt extends Layout {
    textboxRecurringOrderId: Textbox;
}
